import {Component, OnDestroy, ViewChild, AfterViewInit, OnInit, forwardRef} from '@angular/core';
import {ActivatedRoute, NavigationEnd, Router} from '@angular/router';
import {CalendarService} from './calendar.service';
import {ErrorMessage, NotificationService, ResourceLoaderService} from 'inet-core';
import {xCalendar} from "./utils/xCalendar";
import {DateUtils} from "./utils/common/DateUtils";
import {Calendar} from '@fullcalendar/core';
import dayGridPlugin from "@fullcalendar/daygrid";
import timeGridPlugin from "@fullcalendar/timegrid";
import listPlugin from "@fullcalendar/list";
import interactionPlugin from "@fullcalendar/interaction";
import bootstrapPlugin from "@fullcalendar/bootstrap";
import {filter} from "rxjs/operators";
import {CalendarTodayComponent} from "./calendar-today/calendar-today.component";
import {CalendarUtils} from "./CalendarUtils";
import {CalEvent} from "./utils/model/CalEvent";
import {CalendarFormComponent} from "./form/calendar-form.component";
import {CalendarMode} from "./model/calendar-mode";
import {CalendarViewMode} from "./model/calendar-view-mode";
import {CalendarOptions, FullCalendarComponent} from '@fullcalendar/angular';

import * as _moment from 'moment';
import {TaskTracker} from "./utils/model/task";
import application from "@angular-devkit/build-angular/src/babel/presets/application";
const moment = _moment;
declare let iNet: any;
declare let $: any;
@Component({
  selector: 'inet-calendar',
  templateUrl: './calendar.component.html',
  styleUrls: ['./calendar.component.scss'],
})
export class CalendarComponent implements AfterViewInit, OnInit, OnDestroy {
  @ViewChild(CalendarTodayComponent) calendarWidget!: CalendarTodayComponent;
  @ViewChild(CalendarFormComponent) calendarFormComponent!: CalendarFormComponent;
  @ViewChild('fullcalendar') fullcalendar!: FullCalendarComponent;
  viewTypes: CalendarViewMode[] = [
    new CalendarViewMode('Ngày', CalendarMode.timeGridDay, {
      columnHeaderText: (date: Date) => {
        let str = moment(date).format('dddd, D/M/Y');
        return str.slice(0, 1).toUpperCase() + str.slice(1);
      },
      titleFormat: () => CalendarUtils.displayDate(this.calendar ? this.calendar.getDate() : new Date())
    }),
    new CalendarViewMode('Tuần', CalendarMode.timeGridWeek, {
      titleFormat: () => CalendarUtils.displayWeek(this.calendar ? this.calendar.getDate() : new Date())
    }),
    new CalendarViewMode('Tháng', CalendarMode.dayGridMonth, {
      titleFormat: () => CalendarUtils.displayMonth(this.calendar ? this.calendar.getDate() : new Date())
    })
  ];
  trackers: any[] = [];
  statuses  : any[]= [];
  defaultMode: CalendarMode = CalendarMode.dayGridMonth;
  viewTitle: string ='';
  firstDay= 1;

  calendarListType: string = '';
  calendarListValue: string = CalendarMode.timeGridDay;

  calendar?: Calendar;
  isToday: boolean= false;
  viewFormCalendar = false;
  event: CalEvent = {};
  events: any;
  eventsList: any[] = [];
  uuidForm = '';
  disableSave = false;
  disableRemove = false;
  listEvents = [];
  calendarItemsView : any;
  private static dataCached: any;
  private _eventTimer?: any;
  private _modeCache: string = '__calendar_mode__';
  private _routerObserver?: any;
  private _events: any[] = [];
  private _currentRange: any =  { start: Date, end: Date };
  calendarVisible = true;
  calendarOptions?: CalendarOptions;

  constructor(
    private calendarService: CalendarService,
    private route: ActivatedRoute,
    private router: Router,
    private resourceLoader: ResourceLoaderService,
    private notify: NotificationService
  ) {

    // Apply cache config
    /*
    Object.assign(this.calendarConfig, this._getDataView());

    // Merge view config
    this.viewTypes.forEach((view) => {
      if (view.options) {
        this.calendarConfig.views[view.value] = view.options;
      }
    });

    // Use locale
    moment.locale(this.calendarConfig.locale.toString());

     */
  }

  ngAfterViewInit() {
    // this.calendarWidget.loadEvents(this.calendarListValue,this.calendar.view.currentStart);

    // this._hideViewDialog();
    if(this.fullcalendar){
      setTimeout(()=>{
        this.viewTitle = this.fullcalendar.getApi().currentData.viewTitle;
      });
    }
  }

  ngOnInit() {
    // need for load calendar bundle first

  // this.initEvent();
    forwardRef(() => Calendar);
    this.calendarOptions = {
        plugins: [
          dayGridPlugin,
          timeGridPlugin,
          listPlugin,
          interactionPlugin,
          bootstrapPlugin
        ],
        themeSystem: 'bootstrap',
        // headerToolbar: {
        //   left: 'prev,next today',
        //   center: 'title',
        //   right: 'dayGridMonth,timeGridWeek,timeGridDay,listWeek'
        // },
        headerToolbar: false,
        initialView: 'dayGridMonth',
        dateClick: function(arg) {
          console.log(new Date(arg.date.toString()).getTime()); // use *local* methods on the native Date Object
          // will output something like 'Sat Sep 01 2018 00:00:00 GMT-XX:XX (Eastern Daylight Time)'
        } ,
        // events: 'https://fullcalendar.io/demo-events.json',
        eventSources: [
          {
            url: iNet.getPUrl('atlas/redmine/tasks'),
            method: 'POST',
            extraParams: {

            },
            failure: function() {
              // alert('there was an error while fetching events!');
            },
            success: (result)=>{
              return this.convertEvent(result);

            },
            color: 'yellow',   // a non-ajax option
            textColor: 'black' // a non-ajax option
          }

          // any other sources...

        ],

        eventSourceSuccess: function(content, xhr) {
          return content;
        },
        eventMouseEnter: ( mouseEnterInfo ) =>{
          let title = mouseEnterInfo.event._def.title;
          let id = mouseEnterInfo.event._def.publicId || '';
          this.calendarItemsView ={...{id: id},...mouseEnterInfo.event._def.extendedProps} ;
          setTimeout(()=>{
            $(mouseEnterInfo.el).popover({
              trigger: 'hover',
              title: '',
              content:  ()=>{
                var templateCalender : any = document.getElementById("template-calendar-popover") ;
                var __content =  templateCalender.cloneNode(true);
                return  __content;
                },
              html : true,
            }).popover('show');
          });
        },
        eventMouseLeave:function( mouseLeaveInfo ) {
          // $(mouseLeaveInfo.el).popover('hide');
        },
        endParam: 'fromTime',
        startParam: 'toTime',
        weekends: true,
        editable: true,
        selectable: true,
        selectMirror: true,
        dayMaxEvents: true,
        firstDay: this.firstDay,
        locale: 'vi',
        allDaySlot: true,
        allDayText: 'Cả ngày',
        nowIndicator: true,
        navLinks: true, // can click day/week names to navigate views
        droppable: true,
        // contentHeight: "100%",
        // height: '100%',
        expandRows: true,
        views: {},
        businessHours: {
          daysOfWeek: [1, 2, 3, 4, 5],  // Monday - Friday
          startTime: '00:01',
          endTime: '23:59'
        },
        eventDrop: (arg: any) => this._updateEventTime(arg),
        eventResize: (arg: any) => this._updateEventTime(arg),
        select: (arg: any) => this._selectRange(arg),
        eventClick: (arg: any) => this._viewEvent(arg),
        //datesRender: () => this._calendarChange(),
      };
    this._init();
    this.initAttrbute();
    if (CalendarComponent.dataCached) {
      const __dataCached = CalendarComponent.dataCached.mode;
      if (__dataCached) {
        this.calendarListValue = __dataCached;
        if(this.calendar) {
          this.calendarWidget.loadEvents(__dataCached, this.calendar.view.currentStart);
        }
        // setTimeout(() => {
        //     CalendarComponent.dataCached = null;
        // }, 50);
      } else {
        // this.calendarWidget.loadEvents(this.calendarListValue,new Date());
        // setTimeout(() => {
        //     CalendarComponent.dataCached = null;
        // }, 50);
      }
    } else {
      //this.calendarWidget.loadEvents(this.calendarListValue, new Date());
      // setTimeout(() => {
      //     CalendarComponent.dataCached = null;
      // }, 50);
    }

  }
  initAttrbute(){
    this.calendarService.listAttributes().subscribe((result: any) => {
      // this.taskAttribute = result;
      this.statuses = result?.status || [];
      this.trackers = result?.trackers || [];
      // this.priorities  = result?.priority || [];
    });
  }
  convertEvent(result: any){
    let __result : any[] = [];
    let __resultEnd : any[] = [];
    __result = (result.items || []).map((item:any)=>{
      let startday =this.convertDate(item.start_date);
      let dueday = !iNet.isEmpty(item.due_date) ?  this.convertDate(item.due_date) : '';
      if(!iNet.isEmpty(item.due_date)){
        __resultEnd.push({...item,...{
          title: item.tracker_name+  " #"+ item.id +"   " +  item.subject,
          start: dueday,
          color: "red"}});
      }
      return {...item,...{
        title: item.tracker_name+ " #"+ item.id +"   " +  item.subject,
        start: startday,
        // end: dueday,
        color: this.getColorByTracker(item.tracker_name)}
        }});
    this.listEvents =  result.items || [];
    return __result.concat(__resultEnd);
  }
  convertDate(date: any){
    let day = new Date(date);
    let _month = day.getMonth()+1 <10 ? "0"+ (day.getMonth()+1) : day.getMonth()+1;
    let _date = day.getDate() <10 ? "0"+ day.getDate() : day.getDate();
    return  day.getFullYear()+'-'+ _month +'-'+ _date ;
  }

  ngOnDestroy() {
    //this.calendar.destroy();
    this.calendarListValue = CalendarMode.timeGridDay;

    if (this._routerObserver) {
      this._routerObserver.unsubscribe();
    }
  }

  private _init() {
    /*
    this.calendar = new Calendar(this.calendarRef.nativeElement, this.calendarConfig);
    this.calendar.render();

     */

    // Change date view

    this._routerObserver = this.router.events.pipe(
      filter(event => event instanceof NavigationEnd))
      // @ts-ignore
      .subscribe((event: NavigationEnd) => {
        this._onNavigated(event)
      });
  }

  cacheParams() {
    CalendarComponent.dataCached = {
      mode: this.calendarListValue
    };
  }


  private _updateEventTime(args: any) {
    let event;
    if (args.oldEvent) {
      event = this._events[Number(args.oldEvent.id)];
    } else {
      event = this._events[Number(args.event.id)];
    }
    if (event.mode !== 1) {
      let toTime;
      if (args.event.allDay) {
        toTime = 23 * 60 + 59;
      } else {
        toTime = args.event.end.getHours() * 60 + args.event.end.getMinutes();
      }
      let params = {
        element: event.uuid,
        year: args.event.start.getFullYear(),
        day: DateUtils.dayOfYear(args.event.start),
        startTime: args.event.start.getHours() * 60 + args.event.start.getMinutes(),
        toTime: toTime,
        _allday: args.event.allDay
      };
      if (event.repeat) {
        Object.assign(params, event.repeat);
      }
      this.calendarService.updateEvent(params, (data: any, err: any) => {
        if (!data) {
          this.notify.showMessage('Cập nhật lịch không thành công: ' + err.status, 'error');
          args.revert();
          return;
        }
        this.reloadEvents();
      });
    } else {
      // Can't change event
      args.revert();
    }
  }

  createEvent() {
    // let date = new Date();
    if( this.calendar) {
      let date = this.calendar.view.currentStart;

      date.setHours(date.getHours() + 1, 0);
      this._createEvent(date, new Date(date.getTime() + 60 * 60 * 1000));
    }
  }

  private _loadEvents(forceChange: boolean = false) {
    // this._hideViewDialog();
    clearTimeout(this._eventTimer);
    this._eventTimer = setTimeout(() => {
      this._loadRangeEvents(forceChange);
    }, 500);
  }

  private _createEvent(start: Date, end: Date, allDay: boolean = false) {
    const dataBase64 = window.btoa(JSON.stringify({
      start: start.valueOf(),
      end: end.valueOf(),
      attribute: {
        allday: allDay + ''
      }
    }));
    this.events = dataBase64;
    this.event = JSON.parse(atob(dataBase64));
    // this.calendarFormComponent.resetData(this.event);

    // this.router.navigate(['activity/calendar/create', dataBase64]);
    // this._hideViewDialog();
    this.viewFormCalendar = true;
  }

  private _selectRange(info: any) {
    this._createEvent(info.start, info.end, info.start.getTime() === (info.end.getTime() - 24 * 60 * 60 * 1000));
  }

  private _calendarChange() {
    if(this.calendar) {
      if (this.calendar.view.type === CalendarMode.dayGridDay) {
        this.calendar.changeView(CalendarMode.timeGridDay);
        // Trigger change
        setTimeout(() => this._calendarChange());
        return;
      }
    }
    setTimeout(() => {
      this._updateInfo();
      this._loadEvents();
    });
  }

  private _updateInfo() {
    if(this.calendar) {
      this.viewTitle = this.calendar.view.title;
    }
    let __calendarListType = this.viewTitle.split(" ");
    this.calendarListType = __calendarListType[0];
    if(this.calendar) {
      this.viewTypes.forEach((view) => this.calendar && (view.active = view.value === this.calendar.view.type));
    }
    this._checkIsToday();
    this._updateViewParams();
  }

  private _checkIsToday() {
    if(this.calendar) {
      const range = {
        start: this.calendar.view.activeStart,
        end: this.calendar.view.activeEnd,
      };
      this.isToday = this._dateInRange(new Date(), range);
    }
  }

  private _loadRangeEvents(forceChange?: boolean) {
    if (forceChange || this._outOfRange()) {
      this._currentRange = this._getRange();
      this.calendarService.loadEvents(xCalendar.getRangeParams(this._currentRange.start, this._currentRange.end),
        (events: any) => this._renderEvents(events || []));
      if(this.calendar) {
        this.calendar.removeAllEventSources();
      }
    }
  }

  // Range view default is 6 week
  // @ts-ignore
  private _getRange() {
    if(this.calendar) {
      let start = new Date(this.calendar.getDate());
      let end: Date;
      start.setDate(1);
      start.setHours(0, 0, 0, 0);
      while (start.getDay() !== this.firstDay) {
        start.setDate(start.getDate() - 1);
      }
      end = new Date(start.getTime() + 6 * 7 * 24 * 60 * 60 * 1000);
      return {
        start: start,
        end: end
      };
    }
  }

  private _outOfRange(): boolean {
    if (!this._currentRange) {
      return true;
    }
    if(this.calendar) {
      return !(this._dateInRange(this.calendar.view.currentStart) && this._dateInRange(this.calendar.view.currentEnd));
    }
    return false;
  }

  private _dateInRange(date: Date, range: any =  { start: Date, end: Date }) {
    range = range || this._currentRange;
      return date >= range.start && date <= range.end;
  }

  private _renderEvents(events: any[]) {
    this._events = events;
    let eventInputs = events.map((event: any, index: any) => {
      let eventInput: any = {
        id: index,
        uuid: event.uuid,
        allDay: event.allDay,
        title: event.subject,
        start: event.start,
        end: event.end,
      };
      if (event.end < new Date()) {
        // Event on the past
        eventInput.textColor = '#999';
        eventInput.color = '#ddd';
      } else if (event.isCreator) {
        // Owner event
        eventInput.textColor = '#fff';
        eventInput.color = '#4da0d8';
      } else {
        // Other event
        eventInput.textColor = '#333';
        eventInput.color = '#99ed96';
      }
      return eventInput;
    });
    this._addEventSource(eventInputs);
  }

  private _viewEvent(args: any) {
    let event = this._events[Number(args.event.id)];
    console.log('_viewEvent',event, args.jsEvent, args.jsEvent.currentTarget);
    this.calendarService.viewEvent(event, args.jsEvent, args.jsEvent.currentTarget, () => this.reloadEvents());
  }

  private _addEventSource(events: any) {
    if( this.calendar) {
      this.calendar.addEventSource({
        events: events
      });
    }

  }

  private _onNavigated(event: NavigationEnd) {
    const viewData = this._getDataView();
    if( this.calendar) {
      this.calendar.changeView(viewData.defaultView, viewData.defaultDate);
    }
  }

  changeView(type: any) {
    if( this.calendar) {
      this.calendar.changeView(type.value);
    }
    this.calendarListType = type.name;
    this.calendarListValue = type.value;
    this.cacheParams();
    const viewData = this._getDataView();
    this.calendarWidget.loadEvents(type.value, viewData.defaultDate);

  }

  onPrev() {
    if( this.calendar) {
      this.calendar.prev();
      this.calendarWidget.loadEvents(this.calendarListValue, this.calendar.view.currentStart);
    }
  }

  onNext() {
    console.log('this.calendar', this.calendar)
    if( this.calendar) {
      this.calendar.next();
      this.calendarWidget.loadEvents(this.calendarListValue, this.calendar.view.currentStart);

    }
  }

  onToday() {
    if( this.calendar) {
      this.calendar.changeView(CalendarMode.timeGridDay, new Date());
    }
    this.calendarWidget.loadTodayEvents();
    this.viewFormCalendar = false;
    this.calendarListValue = CalendarMode.timeGridDay;
    this.cacheParams();
  }

  private _getCalendarMode(mode: CalendarMode | string) {
    for (let i = 0; i < this.viewTypes.length; i++) {
      if (this.viewTypes[i].value === mode) {
        return this.viewTypes[i];
      }
    }
    return null
  }

  private _updateViewParams() {
    if( this.calendar) {
      let params = [
        this.calendar.view.type,
        moment(this.calendar.getDate()).format('YYYY-M-D')
      ];
      this.router.navigate(['v',  params.join('/')], { relativeTo: this.route });
    }
  }

  private _getDataView() {
    let segments = this.route.snapshot.url;
    let modeView: any = this._cacheModeView();
    let date = new Date();
    if (segments.length > 1) {
      modeView = segments[0].path;
      date = new Date(segments[1].path);
    }
    if (!this._getCalendarMode(modeView)) {
      modeView = this._getCalendarMode(this.defaultMode);
    }
    this._cacheModeView(modeView);
    return {
      defaultView: modeView,
      defaultDate: date,
    };
  }

  private _cacheModeView(modeView?: string) {
    if (modeView === undefined) {
      return localStorage.getItem(this._modeCache);
    } else {
      localStorage.setItem(this._modeCache, modeView);
    }
    return ''
  }

  reloadEvents() {
    // this._hideViewDialog();
    this._loadEvents(true);
    // this.calendarWidget.loadTodayEvents();
  }

  // private _hideViewDialog() {
  //     this.calendarService.hideViewModal();
  // }

  onHideViewDetails($event: any) {
    this.viewFormCalendar = !$event;
  }

  setIDCalendarForm($event: any) {
    this.uuidForm = $event;
  }

  onDisableSave($event: any) {
    this.disableSave = $event
  }

  onDisableRemove($event: any) {
    this.disableRemove = $event
  }

  toogleViewForm() {
    this.viewFormCalendar = false;
  }

  setlistEvents($event: any) {
    this.listEvents = $event;
  }

  onSaveFormCalendar() {
    this.calendarFormComponent.createEvent(() => {
      // this.calendar.changeView(this.calendarListValue,new Date());
      this._loadEvents(true);
      if(this.calendar) {
        this.calendarWidget.loadEvents(this.calendarListValue, this.calendar.view.currentStart);
      }
    });
  }

  reloadEvent($event: any) {
    if(this.calendar) {
      this.calendar.changeView(this.calendarListValue, this.calendar.view.currentStart);
      this.calendarWidget.loadEvents(this.calendarListValue, this.calendar.view.currentStart);
    }
    this._loadEvents(true);
  }

  onRemoveFormCalendar($event: any) {
    this.calendarFormComponent.onRemoveEvent($event);
  }

  getDate() {
    return new Date();
  }

  getColorByTracker(tracker: string): string {
    switch (tracker) {
      case TaskTracker.BUG.valueOf():
        return '#ffc107';
      case TaskTracker.FEATURE.valueOf():
        return '#41a746';break;
      case TaskTracker.SUPPORT.valueOf():
        return '#0878fb';break;
      case TaskTracker.TICKET.valueOf():
        return '#17a2b8';break;
    }
    return '';
  }

}

